<template>
  <div
    class="modal fade"
    id="addCaseVerificationModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="addCaseVerificationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content ">
        <div class="modal-header shadow-sm border-bottom border-outline-light">
          <h6
            class="modal-title font-weight-bold "
            id="addCaseVerificationModalLabel"
          >
            <font-awesome-icon
              :icon="['fas', 'check-double']"
              class="media-icon mr-2"
            />
            Add new verification
          </h6>
          <button
            type="button"
            class="close "
            aria-label="Close"
            @click="closeModal()"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <div class="media-grid no-pseudo">
                  <div v-if="models.media">
                    <div class="img-container">
                      <img :src="helper.formatMediaUrl(models.media)" />
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage(models.media.id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                  </div>
                  <div
                    v-else
                    class="border p-3 h-100 w-100 clickable d-flex flex-column justify-content-center align-items-center rounded bg-grey-light"
                    @click="addImage()"
                    data-placement="bottom"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Click to add picture"
                  >
                    <div v-if="!isLoadingImg" class="text-center">
                      <span class="fa-stack fa-2x">
                        <font-awesome-icon
                          :icon="['fas', 'plus']"
                          class="fa-stack-1x text-muted"
                          style="font-size: 20px"
                        />
                      </span>
                      <p class="text-muted mt-1 small mb-0">Add picture</p>
                    </div>
                    <div v-else class="text-center">
                      <div class="spinner-border text-muted" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <p class="text-muted mt-1 small mb-0">Loading...</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small " for="datetime"
                  >Date &amp; Time</label
                >
                <p
                  class="form-control form-control-default form-control-sm d-flex justify-content-start align-items-center clickable pr-3  bg-dark-input"
                  style="width: fit-content"
                  @click="showDateSelector = true"
                  data-placement="right"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                  title="Click to select date and time"
                >
                  <font-awesome-icon
                    :icon="['far', 'calendar-alt']"
                    class="mr-3"
                  />
                  <span>{{ formatDate(models.datetime) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small ">Remarks</label>
                </div>
                <textarea
                  v-model="models.remarks"
                  rows="5"
                  class="form-control form-control-default form-control-sm  bg-dark-input"
                  style="resize: none"
                  data-placement="top"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                  title="Leave a remarks here"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow border-top border-outline-light">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Click to cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-custom"
            @click="saveChanges()"
            :disabled="isProcessing"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Click to save"
          >
            <div
              class="spinner-border spinner-border-sm "
              v-if="isProcessing"
            ></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
    <date-selector
      v-if="showDateSelector"
      :dateRange="models.datetime"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Helper from "@/helper";
import Swal from "sweetalert2";
import DateSelector from "@/components/DateSelector";

export default {
  name: "add-case-verification-modal",
  props: ["show", "currentCase"],
  components: {
    DateSelector,
  },
  data() {
    return {
      isLoadingImg: false,
      helper: Helper,
      isProcessing: false,
      showDateSelector: false,
      models: {
        media: null,
        remarks: null,
        datetime: null,
      },
      emptyModels: {
        media: null,
        remarks: null,
        datetime: new Date(),
      },
    };
  },
  watch: {
    show: {
      async handler() {
        if (this.show) {
          $("#addCaseVerificationModal").modal("show");

          this.models = JSON.parse(JSON.stringify(this.emptyModels));
        } else {
          $("#addCaseVerificationModal").modal("hide");
        }
      },
      immediate: true,
    },
  },
  computed: {},
  methods: {
    deleteImage(id) {
      this.isLoadingImg = true;
      API.delete(`upload/files/${id}`)
        .then(() => {
          this.isLoadingImg = false;
          Swal.fire("", "Image deleted", "success");
          this.models = {
            ...this.models,
            media: null,
          };
        })
        .catch(() => {
          this.isLoadingImg = false;
          Swal.fire("", "Error deleting image", "error");
          this.models = {
            ...this.models,
            media: null,
          };
        });
    },
    addImage() {
      let uploader = document.createElement("input");
      uploader.type = "file";
      uploader.accept = "image/*";

      uploader.onchange = (event) => {
        if (event.target.files.length < 1) return;

        let fileModels = {
          ref: "verification",
          refId: this.currentCase._id,
          field: "media",
          files: event.target.files,
        };

        let endpoint = "upload";

        let fileName = "files";

        let formData = new FormData();

        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            fileModels[key].forEach((file) => {
              formData.append(fileName, file);
            });
          }
        });
        this.isLoadingImg = true;
        API.postForm(endpoint, formData)
          .then(async (retVal) => {
            if (retVal.data.length > 0) {
              this.isLoadingImg = false;
              let currentVerification = this.currentCase.verifications.find(
                (v) => v._id == parentId
              );

              if (currentVerification) {
                currentVerification.media.push(data);
              }

              this.models = {
                ...this.models,
                media: retVal.data[0],
              };
            }
          })
          .catch(() => {
            this.isLoadingImg = false;
            Swal.fire("", "Error deleting image", "error");
          });
      };
      uploader.click();
    },
    dateSelected(e) {
      if (e) {
        this.models.datetime = e;
      }

      this.showDateSelector = false;
    },
    formatDate(datetime) {
      return Helper.formatDate(datetime, true);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        if (response) {
          this.$emit("close", response);
        } else {
          this.$emit("close");
        }

        if (response) {
          this.$emit("getCases");
        }
      }
    },
    saveChanges() {
      if (!this.models.datetime) {
        this.isProcessing = false;

        return Swal.fire("Invalid date", "", "error");
      }

      this.models.case = this.currentCase._id;

      Swal.fire({
        html: "Reopen this case?",
        icon: "question",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-primary mx-1",
          cancelButton: "btn btn-sm btn-danger mx-1",
          actions: "d-flex justify-content-center align-items-center",
        },
      }).then((result) => {
        this.isProcessing = true;

        API.post(`verifications`, {
          ...this.models,
          media: this.models.media.id,
        })
          .then(async (retVal) => {
            if (result.isConfirmed) {
              API.put(`cases/${this.currentCase.id}`, {
                status: "pending",
              })
                .then((response) => {
                  this.isProcessing = false;

                  this.closeModal(retVal.data);
                })
                .catch(() => {
                  this.isProcessing = false;
                });
            }
            this.isProcessing = false;

            this.closeModal(retVal.data);
          })
          .catch((err) => {
            this.isProcessing = false;

            console.error(err);
          });
      });
    },
  },
};
</script>